import { useState } from "react";

/**
 * Holds form-level error messages, typically set from a mutation's
 * `problems` payload and rendered with `ErrorAlerts`.
 */
export function useFormErrors(): [string[], (messages: string[]) => void] {
  return useState<string[]>([]);
}
